import { render, staticRenderFns } from "./GateForm.vue?vue&type=template&id=4cb168ac"
import script from "./GateForm.vue?vue&type=script&lang=ts"
export * from "./GateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports